import { StrictMode } from "react"
import { createRoot } from "react-dom/client"

import { App } from "./App.js"
import "./styles.css"

export const mountApplication = (element: HTMLElement | null): void => {
  if (element === null) throw new Error("Application root is missing.")
  createRoot(element).render(<StrictMode><App /></StrictMode>)
}
